import { useMemo } from 'react';

import { getDraftSearch } from '../store';
import { UNIVERSAL_FILTER_SEARCH_FIELD } from '../types';
import { useUniversalFiltersContext } from '../UniversalFiltersProvider';

import { useUniversalFiltersSelector } from './useUniversalFiltersSelector';

/**
 * Maps the active generic draft into the page payload.
 *
 * The reserved search clause reaches the mapper as `search`, not as a
 * filter, and only on a page with a search input. Clauses with nullish values
 * are omitted before the page-owned mapper runs.
 */
export function useUniversalFilterPayload<TPayload>() {
  const { config } = useUniversalFiltersContext<TPayload>();
  const draft = useUniversalFiltersSelector((context) => context.draft);

  return useMemo(
    () =>
      config.mapToPayload({
        filters: draft.filter(
          (clause) =>
            clause.value != null &&
            clause.field !== UNIVERSAL_FILTER_SEARCH_FIELD,
        ),
        search: config.search ? getDraftSearch(draft) : '',
      }),
    [config, draft],
  );
}
